// extracted by mini-css-extract-plugin
export default {"container":"main-section_container__UbUds","error":"main-section_error__0IGTO"};